module.exports = __webpack_public_path__ + "comp-2.png?159412b2e3f00907f39c0a0422fb4283";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/comp-2.png
// module id = xv00
// module chunks = 50